(function() {
    const SCROLL_KEY = 'collection_scroll_pos';
    const PAGE_KEY = 'collection_target_page';
    const URL_KEY = 'collection_saved_url';

    console.log('[ScrollRestore] Script loaded!');

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    // --- Helpers ---
    const injectStyles = () => {
        if (document.getElementById('scroll-loader-style')) return;
        const style = document.createElement('style');
        style.id = 'scroll-loader-style';
        style.innerHTML = `
            #custom-scroll-loader {
                position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                background: rgba(255, 255, 255, 0.95);
                display: flex; align-items: center; justify-content: center;
                z-index: 999999;
            }
            .custom-spinner {
                width: 50px; height: 50px;
                border: 5px solid #f3f3f3;
                border-top: 5px solid #A16B82;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
            }
            @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `;
        document.head.appendChild(style);
    };

    const showLoader = () => {
        injectStyles();
        if (!document.getElementById('custom-scroll-loader')) {
            const loader = document.createElement('div');
            loader.id = 'custom-scroll-loader';
            loader.innerHTML = '<div class="custom-spinner"></div>';
            document.body.appendChild(loader);
            document.body.style.overflow = 'hidden';
        }
    };

    const hideLoader = () => {
        const loader = document.getElementById('custom-scroll-loader');
        if (loader) {
            loader.remove();
            document.body.style.overflow = '';
        }
    };

    const getCurrentLoadedPages = () => {
        const container = document.querySelector('.collection__grid-wrapper');
        if (!container) return 1;
        const items = container.querySelectorAll('.collection__item').length;
        return Math.ceil(items / 32);
    };

    // --- Save Data ---
    const saveData = () => {
        const scroll = window.scrollY;
        const url = window.location.pathname;
        const pages = getCurrentLoadedPages();
        sessionStorage.setItem(SCROLL_KEY, scroll);
        sessionStorage.setItem(URL_KEY, url);
        sessionStorage.setItem(PAGE_KEY, pages);
        console.log('[ScrollRestore] SAVED → pos:', scroll, '| pages:', pages);
    };

    document.addEventListener('click', (e) => {
        if (e.target.closest('a[href*="/products/"]')) saveData();
    });

    // --- Restore Data ---
    const restoreContent = () => {
        const savedUrl = sessionStorage.getItem(URL_KEY);
        const currentUrl = window.location.pathname;
        const targetPage = parseInt(sessionStorage.getItem(PAGE_KEY));
        const savedPos = parseInt(sessionStorage.getItem(SCROLL_KEY));

        if (!savedUrl || savedUrl !== currentUrl || !targetPage) {
            hideLoader(); // Safety check
            return;
        }

        if (targetPage <= 1) {
            if (savedPos) {
                setTimeout(() => window.scrollTo({ top: savedPos, behavior: 'instant' }), 300);
                clearStorage();
            }
            return;
        }

        showLoader();
        let currentLoadedPage = 1;
        const container = document.querySelector('.collection__grid-wrapper');

        const clickNextPage = () => {
            const btn = document.querySelector('.collection__load-more-button');

            // Agar button khatam ho jaye ya target page mil jaye
            if (!btn || currentLoadedPage >= targetPage) {
                console.log('[ScrollRestore] Finished loading, scrolling now...');
                setTimeout(() => {
                    window.scrollTo({ top: savedPos, behavior: 'instant' });
                    hideLoader();
                    clearStorage();
                }, 500); 
                return;
            }

            // Observer lagayein Click se pehle
            const observer = new MutationObserver((mutations, obs) => {
                obs.disconnect(); // Items milte hi observer band
                currentLoadedPage++;
                console.log('[ScrollRestore] Page Loaded:', currentLoadedPage);
                clickNextPage(); // Agla page click karein
            });

            if (container) {
                observer.observe(container, { childList: true, subtree: true });
            }

            btn.click();
        };

        clickNextPage();
    };

    const clearStorage = () => {
        sessionStorage.removeItem(SCROLL_KEY);
        sessionStorage.removeItem(PAGE_KEY);
        sessionStorage.removeItem(URL_KEY);
    };

    // Events
    window.addEventListener('pageshow', (e) => {
        // e.persisted check karta hai ke kya page cache se load hua
        restoreContent();
    });

    document.addEventListener('pjax:end', restoreContent);

})();